export default "__VITE_ASSET__8f8f7e06__"